import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class InstitutionReviApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
    this.routes = ENV.API_ROUTES;
  }

  /**
   * Obtiene el perfil completo de la institución (Datos + Plan + Stats)
   * Endpoint: /institutionreviprofile/get/:id
   */
  async getProfile(token, institutionId) {
    try {
      // Usamos la constante definida en constants.js (INSTITUTION_PROFILE)
      const url = `${this.baseApi}/${this.routes.INSTITUTION_PROFILE}/get/${institutionId}`;

      const response = await fetch(url, {
        method: "GET",
        headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      });

      const json = await response.json();

      if (response.status !== 200) {
        throw new Error(
          json.message || "Error al obtener el perfil de la institución",
        );
      }

      // Normalizamos la respuesta para que la Vista siempre reciba la misma estructura
      const institution = json.institution || json;

      // El backend devuelve la ocupacion real aparte, porque pacientesN y
      // terapeutasN son el CUPO CONTRATADO y no cuantos hay. Se adjunta al
      // objeto en vez de cambiar la forma de retorno, para no tocar a quien ya
      // lo consume.
      if (json.ocupacion) institution.ocupacion = json.ocupacion;

      return institution;
    } catch (error) {
      console.error("InstitutionReviApi Error:", error);
      throw error;
    }
  }
}
